export default __webpack_public_path__ + "media/zurb/img/work/work-case-study-thumbnail1-2bc0cb70ad6947db67d50ba71403123f.png";